/**
 * Formats a number as currency.
 * @param {number} value - The number to format
 * @param {string} [currency="USD"] - The currency code (e.g., "USD", "EUR", "GBP")
 * @returns {string} The formatted currency string
 */
export function formatCurrency(value, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency
  }).format(value ?? 0)
}
